<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card dark outlined>
          <v-card-title class="secondary py-1 text-subtitle-1">
            <v-icon left dense> mdi-home </v-icon>
            Products
            <v-spacer />
          </v-card-title>
          <v-card-text class="pa-0">
            <v-data-table
              :headers="headers"
              :items="filteredProducts"
              single-select
              class="elevation-5"
              :item-class="itemRowBackground"
            >
              <template v-slot:item.TagIds="{ item }">
                {{ item.TagIds ? handleCheckTags(item.TagIds).join(", ") : "" }}
              </template>
              <template v-slot:item.CategoryName="{ item }">
                {{ getCategoryName(item.CategoryId) }}
              </template>
              <template v-slot:item.DiscountSurchargePercentage="{ item }">
                {{
                  item.DiscountSurchargePercentage === 0
                    ? ""
                    : item.DiscountSurchargePercentage
                }}
              </template>
              <template v-slot:top>
                <v-toolbar flat>
                  <v-row>
                    <v-row class="mt-2">
                      <v-col cols="4">
                        <v-autocomplete
                          :items="currentStallHolders"
                          v-model="selectedStallHolder"
                          item-text="StallholderName"
                          return-object
                          filled
                          dense
                          outlined
                          hide-details
                          label="StallHolders"
                          @change="handleChangeStallHolder"
                        >
                          <template v-slot:no-data>
                            <v-list-item>
                              <v-list-item-title>
                                <v-icon small color="red lighten-1">
                                  mdi-information
                                </v-icon>
                                No event found
                              </v-list-item-title>
                            </v-list-item>
                          </template>
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="4">
                        <v-combobox
                          filled
                          dense
                          outlined
                          v-model="selectedCategoryFilter"
                          :items="categoryFilterList"
                          label="Filter by Category"
                          item-text="CategoryName"
                          item-value="CategoryId"
                          return-object
                          clearable
                        >
                        </v-combobox>
                      </v-col>
                    </v-row>
                  </v-row>

                  <v-dialog v-model="dialog" max-width="800px" dark>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        small
                        dark
                        class="mb-2"
                        v-bind="attrs"
                        v-on="on"
                        :disabled="!selectedStallHolder.StallholderId"
                      >
                        <v-icon left x-small> mdi-plus </v-icon>
                        Add Products
                      </v-btn>

                      <v-btn
                        :disabled="!selectedStallHolder.StallholderId"
                        @click="handleCreateIsCashOut"
                        class="mr-3 mb-2"
                        small
                        dark
                        v-bind:class="{ gray: !IsCashOut, green: IsCashOut }"
                        v-on:click="IsCashOut = !IsCashOut"
                      >
                        <v-checkbox
                          v-model="IsCashOut"
                          hide-details
                          v-on:click="IsCashOut = !IsCashOut"
                        ></v-checkbox>

                        Enable Cash Out
                      </v-btn>

                      <v-btn
                        :disabled="!selectedStallHolder.StallholderId"
                        @click="handleCreateManualProduct"
                        class="mr-3 mb-2"
                        small
                        dark
                        v-bind:class="{
                          gray: !ManualProduct,
                          green: ManualProduct,
                        }"
                        v-on:click="ManualProduct = !ManualProduct"
                      >
                        <v-checkbox
                          v-model="ManualProduct"
                          hide-details
                          v-on:click="ManualProduct = !ManualProduct"
                        ></v-checkbox>

                        Enable Manual Product
                      </v-btn>
                    </template>
                    <v-card>
                      <v-card-title class="text-h6">
                        {{ formTitle }}
                      </v-card-title>
                      <v-divider></v-divider>

                      <v-card-text>
                        <v-container>
                          <v-form ref="form" v-model="valid" lazy-validation>
                            <v-row>
                              <v-col cols="6">
                                <label
                                  ><B>Event :-</B>
                                  {{
                                    selectedEvent.EventName
                                      ? selectedEvent.EventName
                                      : "N/A"
                                  }}</label
                                >
                              </v-col>
                              <v-col cols="6">
                                <label
                                  ><B>Stallholder :-</B>
                                  {{
                                    selectedStallHolder.StallholderName
                                      ? selectedStallHolder.StallholderName
                                      : "N/A"
                                  }}</label
                                >
                              </v-col>
                              <!-- <v-col cols="4">
                                    <label><B>Stall :-</B> {{ selectedStall.StallName ? selectedStall.StallName : 'N/A'}}</label>
                                </v-col> -->
                            </v-row>

                            <!-- Discount Surcharge Checkbox -->
                            <v-row>
                              <v-col cols="12">
                                <v-checkbox
                                  v-model="editedItem.DiscountSurchargeItem"
                                  label="Discount Surcharge Item"
                                  @change="toggleDiscountSurchargeFields"
                                ></v-checkbox>
                              </v-col>
                            </v-row>

                            <!-- Regular Product Fields -->
                            <v-row v-if="!editedItem.DiscountSurchargeItem">
                              <v-col cols="4">
                                <v-combobox
                                  v-model="editedItem.CategoryId"
                                  :items="CategoryList"
                                  label="Categories"
                                  item-text="CategoryName"
                                >
                                </v-combobox>
                              </v-col>
                              <v-col cols="4">
                                <v-combobox
                                  v-model="editedItem.TagIds"
                                  multiple
                                  :items="TagList"
                                  label="Tag"
                                  item-text="TagName"
                                >
                                </v-combobox>
                              </v-col>
                              <v-col cols="4">
                                <v-combobox
                                  v-model="editedItem.ProductOptionIds"
                                  multiple
                                  :items="ProductOptionList"
                                  label="Product Options"
                                  item-text="ProductOptionName"
                                >
                                </v-combobox>
                              </v-col>
                            </v-row>

                            <v-text-field
                              v-model="editedItem.ProductName"
                              label="Product Name"
                              :rules="[
                                (v) => !!v || 'Product Name is required',
                              ]"
                            ></v-text-field>

                            <v-text-field
                              v-model="editedItem.ShortName"
                              label="Short Name"
                            ></v-text-field>

                            <!-- Discount Surcharge Specific Fields -->
                            <div v-if="editedItem.DiscountSurchargeItem">
                              <v-text-field
                                v-model="editedItem.DiscountSurchargePercentage"
                                type="number"
                                label="Discount Surcharge (%)"
                                :rules="[
                                  (v) =>
                                    !!v || 'Discount Surcharge (%) is required',
                                ]"
                              ></v-text-field>

                              <v-checkbox
                                v-model="editedItem.DiscountSurchargeManager"
                                label="Discount Surcharge Manager"
                              ></v-checkbox>
                            </div>

                            <!-- Regular Product Fields -->
                            <div v-if="!editedItem.DiscountSurchargeItem">
                              <v-text-field
                                v-model="editedItem.Price"
                                type="number"
                                label="Price"
                                :rules="[(v) => !!v || 'Price is required']"
                              ></v-text-field>

                              <v-text-field
                                v-model="editedItem.StandardDrinks"
                                type="number"
                                label="Standard Drinks"
                                :rules="[
                                  (v) => !!v || 'Standard Drinks is required',
                                ]"
                              ></v-text-field>

                              <v-btn
                                class="mr-3"
                                small
                                dark
                                v-bind:class="{
                                  gray: !editedItem.GstFlag,
                                  green: editedItem.GstFlag,
                                }"
                                v-on:click="
                                  editedItem.GstFlag = !editedItem.GstFlag
                                "
                              >
                                <v-checkbox
                                  class="mb-5"
                                  v-model="editedItem.GstFlag"
                                  hide-details
                                  v-on:click="
                                    editedItem.GstFlag = !editedItem.GstFlag
                                  "
                                ></v-checkbox>
                                GST Applicable
                              </v-btn>
                            </div>

                            <v-divider class="mt-5 mb-5"></v-divider>

                            <!-- Start of stall products -->
                            <!-- <span class="mt-4 mb-4">Stall Products</span>
                              <v-row v-for="(item, index) in stallProducts" :key="index">
                                <v-col cols="3" class="mt-3">
                                  <v-autocomplete
                                      :items="stalls"
                                      v-model="item.StallIds"
                                      item-text="StallName"
                                      return-object
                                      filled
                                      dense
                                      outlined
                                      hide-details
                                      label="Stalls"
                                  >
                                      <template v-slot:no-data>
                                      <v-list-item>
                                          <v-list-item-title>
                                          <v-icon small color="red lighten-1">
                                              mdi-information
                                          </v-icon>
                                          No event found
                                          </v-list-item-title>
                                      </v-list-item>
                                      </template>
                                  </v-autocomplete>
                                </v-col>
                                <v-col cols="2">
                                  <v-text-field
                                    v-model="item.ProductName"
                                    label="Product Name"
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="2">
                                  <v-text-field
                                    v-model="item.ShortName"
                                    label="Short Name"
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="2">
                                  <v-text-field
                                    v-model="item.Price"
                                    type="number"
                                    label="Price"
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="3" class="mt-5">
                                  <v-btn
                                    color="red lighten-2"
                                    x-small
                                    v-show="index || (!index && stallProducts.length > 1)"
                                    @click="removeRow(index)"
                                  >
                                  Remove
                                  </v-btn> &nbsp;
                                  <v-btn
                                    color="lighten-2"
                                    x-small
                                    @click="addRow()"
                                  >
                                  Add
                                  </v-btn>
                                </v-col>
                              </v-row> -->

                            <!-- End of stall products -->

                            <!-- <v-row>
                                    <v-col cols="6">
                                        <label>Text Color</label>
                                        <v-color-picker
                                            dot-size="25"
                                            mode="hexa"
                                            hide-mode-switch
                                            swatches-max-height="150"
                                            v-model="editedItem.TextColor"
                                        ></v-color-picker>
                                    </v-col>
                                    <v-col cols="6">
                                        <label>Background Color</label>
                                        <v-color-picker
                                            dot-size="25"
                                            mode="hexa"
                                            hide-mode-switch
                                            swatches-max-height="150"
                                            v-model="editedItem.BackgroundColor"
                                        ></v-color-picker>
                                    </v-col>
                               </v-row> -->
                            <!-- </v-col> -->
                          </v-form>
                        </v-container>
                      </v-card-text>

                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="close">
                          Cancel
                        </v-btn>
                        <v-btn color="blue darken-1" text @click="save">
                          Save
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  <v-dialog dark v-model="dialogDelete" max-width="500px">
                    <v-card>
                      <v-card-title class="text-h5"
                        >Are you sure you want to delete Product ?</v-card-title
                      >
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="closeDelete"
                          >Cancel</v-btn
                        >
                        <v-btn
                          color="blue darken-1"
                          text
                          @click="deleteItemConfirm"
                          >OK</v-btn
                        >
                        <v-spacer></v-spacer>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-toolbar>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-icon
                  v-if="!item.ManualProduct && !item.IsCashOut"
                  small
                  class="mr-2"
                  @click="editItem(item)"
                >
                  mdi-pencil
                </v-icon>
                <v-icon
                  v-if="!item.ManualProduct && !item.IsCashOut"
                  small
                  @click="deleteItem(item)"
                >
                  mdi-delete
                </v-icon>
              </template>
              <template v-slot:no-data>
                <v-btn color="primary"> No product for this event </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import "izitoast/dist/css/iziToast.min.css"; // loading css
import iziToast from "izitoast/dist/js/iziToast.min.js"; // you have access to iziToast now
import { mapState, mapActions, mapMutations } from "vuex";

export default {
  props: {
    productsData: {
      type: Object,
      default: () => ({
        products: [],
        productCategories: [],
        stallholderTags: [],
        productOptions: [],
      }),
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    dialog: false,
    dialogDelete: false,

    selectedStall: "",
    stalls: [],
    headers: [
      { text: "Product Name", value: "ProductName" },
      { text: "Short Name", value: "ShortName" },
      // { text: "Tag(s)", value: "TagIds" },
      { text: "Category", value: "CategoryName" },
      { text: "Price ($)", value: "Price" },
      { text: "Discount Surcharge (%)", value: "DiscountSurchargePercentage" },
      { text: "Standard Drinks", value: "StandardDrinks" },
      { text: "Actions", value: "actions", sortable: false },
    ],

    editedIndex: -1,
    editedItem: {
      EventId: "",
      StallholderId: "",
      CategoryId: "",
      TagIds: [],
      ProductOptionIds: "",
      ProductName: "",
      ShortName: "",
      Price: "",
      DiscountSurchargePercentage: 0,
      StandardDrinks: "",
      GstFlag: true,
      DiscountSurchargeManager: false,
      DiscountSurchargeItem: false,
      MandatoryOptions: false,
      ManualProduct: false,
      IsCashOut: false,
    },
    defaultItem: {
      EventId: "",
      StallholderId: "",
      CategoryId: "",
      TagIds: [],
      ProductOptionIds: "",
      ProductName: "",
      ShortName: "",
      Price: "",
      DiscountSurchargePercentage: 0,
      StandardDrinks: "",
      GstFlag: true,
      DiscountSurchargeManager: false,
      DiscountSurchargeItem: false,
      MandatoryOptions: false,
      ManualProduct: false,
      IsCashOut: false,
    },

    ManualProductObj: {},
    ManualProduct: false,
    IsCashOutProductObj: {},
    IsCashOut: false,

    valid: true,
    selectedCategoryFilter: null,
  }),

  computed: {
    ...mapState("filter", ["globalEventFilter"]),
    ...mapState("admin", ["currentStallHolders", "currentStallholder"]),

    allProducts() {
      return this.productsData.products || [];
    },

    CategoryList() {
      return this.productsData.productCategories || [];
    },

    TagList() {
      return this.productsData.stallholderTags || [];
    },

    ProductOptionList() {
      return this.productsData.productOptions || [];
    },

    formTitle() {
      return this.editedIndex === -1 ? "New Product" : "Edit Product";
    },

    selectedEvent: {
      get() {
        return this.globalEventFilter;
      },
      set(value) {
        console.log("EVENT IS CHANGED MAKE API REQUEST", value);
      },
    },

    selectedStallHolder: {
      get() {
        return this.currentStallholder;
      },
      set(value) {
        this.setCurrentStallholder(value);
      },
    },

    filteredProducts() {
      if (
        !this.selectedCategoryFilter ||
        this.selectedCategoryFilter.CategoryId === ""
      ) {
        return this.allProducts.filter((product) => !product.Deleted);
      }
      return this.allProducts.filter(
        (product) =>
          product.CategoryId === this.selectedCategoryFilter.CategoryId &&
          !product.Deleted
      );
    },

    categoryFilterList() {
      const allCategoriesOption = {
        CategoryId: "",
        CategoryName: "All Categories",
      };
      return [allCategoriesOption, ...this.CategoryList];
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    productsData: {
      handler(newData) {
        if (newData && newData.products) {
          // Update special product flags when data changes
          this.updateSpecialProductFlags(newData.products);
        }
      },
      immediate: true,
    },
  },

  methods: {
    ...mapActions("admin", ["createCategories"]),
    ...mapMutations("admin", ["setCurrentStallholder"]),

    updateSpecialProductFlags(products) {
      // Manual Product
      this.ManualProductObj = products.find(
        (product) => product.ManualProduct && !product.Deleted
      );
      this.ManualProduct = this.ManualProductObj?.ManualProduct ?? false;

      // CashOut Product
      this.IsCashOutProductObj = products.find(
        (product) => product.IsCashOut && !product.Deleted
      );
      this.IsCashOut = this.IsCashOutProductObj?.IsCashOut ?? false;
    },

    itemRowBackground: function (item) {
      return item.ManualProduct === true
        ? "indigo"
        : item.IsCashOut === true
        ? "indigo"
        : "";
    },

    getCategoryName: function (categoryId) {
      // Return empty string if no categoryId
      if (!categoryId) {
        return "";
      }

      // Find the category in CategoryList that matches the categoryId
      const category = this.CategoryList.find(
        (cat) => cat.CategoryId === categoryId
      );

      // Return CategoryName if found, otherwise return empty string
      return category ? category.CategoryName : "";
    },

    handleCheckTags: function (tagIds) {
      // Check if tagIds exists and is an array
      if (!tagIds || !Array.isArray(tagIds) || tagIds.length === 0) {
        return [];
      }

      var result = this.TagList.filter(function (o1) {
        return tagIds.some(function (o2) {
          return o1.TagId === o2;
        });
      }).map(function (o) {
        return o.TagName;
      });
      return result;
    },

    handleCheckProductOptionIds: function (OptionIds) {
      // Check if OptionIds exists and is an array
      if (!OptionIds || !Array.isArray(OptionIds) || OptionIds.length === 0) {
        return [];
      }

      var result = this.ProductOptionList.filter(function (o1) {
        return OptionIds.some(function (o2) {
          return o1.ProductOptionId === o2;
        });
      }).map(function (o) {
        return o.ProductOptionName;
      });
      return result;
    },

    handleChangeStallHolder: function (obj) {
      if (obj) {
        this.setCurrentStallholder(obj);
        this.stalls = obj.Stalls;

        // Reset category filter to "All Categories" when stallholder changes
        this.selectedCategoryFilter = {
          CategoryId: "",
          CategoryName: "All Categories",
        };

        // Note: Data will be refreshed by parent component
      }
    },

    toggleDiscountSurchargeFields() {
      if (this.editedItem.DiscountSurchargeItem) {
        // Set default values for discount surcharge
        this.editedItem.Price = null;
        this.editedItem.StandardDrinks = null;
        this.editedItem.GstFlag = false;
        this.editedItem.CategoryId = "TBC";
        this.editedItem.TagIds = [];
        this.editedItem.ProductOptionIds = [];
        // Set default name if creating new discount surcharge item
        if (!this.editedItem.ProductName) {
          this.editedItem.ProductName = "Discount Surcharge Item";
          this.editedItem.ShortName = "Discount Surcharge Item";
        }
      } else {
        // Clear discount surcharge specific fields
        this.editedItem.DiscountSurchargePercentage = null;
        this.editedItem.DiscountSurchargeManager = false;
        this.editedItem.CategoryId = null;
        // Set default name if creating new discount surcharge item
        if (this.editedItem.ProductName === "Discount Surcharge Item") {
          this.editedItem.ProductName = "";
        }
        if (this.editedItem.ShortName === "Discount Surcharge Item") {
          this.editedItem.ShortName = "";
        }
        // Reset to default values for regular products
        this.editedItem.Price = null;
        this.editedItem.StandardDrinks = null;
        this.editedItem.GstFlag = true;
      }
    },

    editItem(item) {
      this.editedIndex = this.allProducts.indexOf(item);
      console.log("item");
      console.log(item);

      this.editedItem.EventId = item.EventId;
      this.editedItem.StallholderId = item.StallholderId;

      this.editedItem.CategoryId = this.CategoryList.filter((element) => {
        return element.CategoryId === item.CategoryId;
      });
      this.editedItem.CategoryId =
        this.editedItem.CategoryId.length > 0
          ? this.editedItem.CategoryId[0]
          : null;

      this.editedItem.TagIds = this.handleCheckTags(item.TagIds);
      this.editedItem.ProductOptionIds = this.handleCheckProductOptionIds(
        item.ProductOptionIds
      );

      this.editedItem.ProductId = item.ProductId;
      this.editedItem.ProductName = item.ProductName;
      this.editedItem.ShortName = item.ShortName;
      this.editedItem.Price = item.Price;
      this.editedItem.DiscountSurchargePercentage =
        item.DiscountSurchargePercentage || 0;
      this.editedItem.DiscountSurchargeManager =
        item.DiscountSurchargeManager || false;
      this.editedItem.DiscountSurchargeItem =
        item.DiscountSurchargeItem || false;
      this.editedItem.MandatoryOptions = item.MandatoryOptions;
      this.editedItem.StandardDrinks = item.StandardDrinks;

      // stall Product section
      // this.editedItem.stallProducts = [];

      let selected = this.currentStallHolders.filter((element) => {
        return element.StallholderId === item.StallholderId;
      });

      if (selected.length > 0) {
        this.setCurrentStallholder(selected[0]);
      }

      this.dialog = true;
    },

    deleteItem(item) {
      this.editedIndex = this.allProducts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      try {
        if (this.editedItem.StallholderId) {
          let event_item = [
            {
              Type: "product",
              Action: "delete",
              Properties: this.editedItem,
            },
          ];

          let submitEvent = {
            event_items: event_item,
          };
          this.createCategories(submitEvent)
            .then((response) => {
              console.log("response");
              console.log(response);

              iziToast.success({
                title: "Product",
                message: "Successfully delete record!",
                position: "topRight",
              });

              this.$emit("refresh-data");
            })
            .catch((err) => {
              console.log("err");
              console.log(err);

              iziToast.warning({
                title: "Stallholder",
                message: "Fail to delete record!",
                position: "topRight",
              });

              this.$emit("refresh-data");
            });
        }
      } catch (e) {
        console.log(e);
      }

      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    // addRow() {
    //   let x = this.stallProducts.length - 1;

    //   if (this.stallProducts[x].StallIds && this.stallProducts[x].ProductName && this.stallProducts[x].ShortName && this.stallProducts[x].Price) {
    //     this.stallProducts.push({});
    //   }

    //   for (var j = 0; j < this.stallProducts.length - 1; j++) {
    //     if (this.stallProducts[j].StallIds.StallId !== undefined) {
    //       this.stalls = this.stalls.map(obj=>{
    //         if (obj.StallId === this.stallProducts[j].StallIds.StallId) {
    //           obj.disabled = true;
    //         }
    //         return obj;
    //       });

    //     }
    //   }

    // },

    // removeRow(index) {
    //   for (var j = 0; j < this.stallProducts.length; j++) {
    //     if (this.stallProducts[j].StallIds && this.stallProducts[j].StallIds !== undefined &&  this.stallProducts[j].StallIds.StallId !== undefined) {
    //       this.stalls = this.stalls.map(obj=>{
    //         if (obj.StallId === this.stallProducts[j].StallIds.StallId) {
    //           obj.disabled = false;
    //         }
    //         return obj;
    //       });

    //     }
    //   }

    //   this.stallProducts.splice(index, 1);
    // },

    save() {
      console.log("Starting save()", this.editedItem);
      if (this.$refs.form.validate()) {
        try {
          if (this.$refs.form.validate()) {
            this.editedItem.EventId = this.selectedEvent.EventId;
            this.editedItem.StallholderId =
              this.selectedStallHolder.StallholderId;

            // Handle discount surcharge items
            if (this.editedItem.DiscountSurchargeItem) {
              // Ensure required fields for discount surcharge
              if (!this.editedItem.DiscountSurchargePercentage) {
                iziToast.warning({
                  title: "Validation Error",
                  message: "Discount Surcharge (%) is required!",
                  position: "topRight",
                });
                return;
              }
              // Set default values for discount surcharge items
              this.editedItem.Price = null;
              this.editedItem.StandardDrinks = null;
              this.editedItem.GstFlag = false;
              this.editedItem.CategoryId = "TBC";
              this.editedItem.TagIds = [];
              this.editedItem.ProductOptionIds = [];
            } else {
              // Handle regular products
              this.editedItem.CategoryId =
                this.editedItem.CategoryId &&
                this.editedItem.CategoryId.CategoryId;
              this.editedItem.TagIds = this.editedItem.TagIds.map((obj) => {
                return obj.TagId;
              });
              console.log(
                "save () this.editedItem.ProductOptionIds: ",
                this.editedItem.ProductOptionIds
              );
              if (this.editedItem.ProductOptionIds !== "") {
                this.editedItem.ProductOptionIds =
                  this.editedItem.ProductOptionIds.map((obj) => {
                    return obj.ProductOptionId;
                  });
              } else {
                delete this.editedItem.ProductOptionIds;
              }
              // Clear discount surcharge fields for regular products
              this.editedItem.DiscountSurchargePercentage = 0;
              this.editedItem.DiscountSurchargeManager = false;
            }

            // if (this.stallProducts.length !== 0) {
            //   this.stallProducts = this.stallProducts.map(obj=>{
            //     obj.StallIds = obj.StallIds.StallId;
            //     return obj;
            //   });

            //   this.editedItem.StallProducts = this.stallProducts;
            // }
            console.log("editedItem");
            console.log(this.editedItem);
            let event_item = [
              {
                Type: "product",
                Action: this.editedIndex === -1 ? "Create" : "Edit",
                Properties: this.editedItem,
              },
            ];

            let submitEvent = {
              event_items: event_item,
            };
            console.log("submitEvent");
            console.log(submitEvent);
            this.createCategories(submitEvent)
              .then((response) => {
                console.log("response");
                console.log(response);

                iziToast.success({
                  title: "Product",
                  message: "Successfully inserted record!",
                  position: "topRight",
                });

                this.$emit("refresh-data");
              })
              .catch((err) => {
                console.log("err");
                console.log(err);

                iziToast.warning({
                  title: "Product",
                  message: "Fail to inserted record!",
                  position: "topRight",
                });
              });
          }
        } catch (e) {
          console.log(e);
        }
        this.close();
      }
    },
    // Manual Product
    handleCreateManualProduct: function () {
      if (!this.ManualProduct) {
        try {
          let submitEvent = {};
          let isAction = "Create";
          const foundManualProduct = this.allProducts.find(
            (product) => product.ManualProduct && product.Deleted
          );
          if (foundManualProduct) {
            submitEvent = { ...foundManualProduct };
            isAction = "Edit";
          } else {
            submitEvent.ManualProduct = true;
            submitEvent.EventId = this.selectedEvent.EventId;
            submitEvent.StallholderId = this.selectedStallHolder.StallholderId;
            submitEvent.CategoryId = "TBC";
            submitEvent.ProductName = "Manual Product";
            submitEvent.ShortName = "Manual Product";
          }
          submitEvent.Deleted = false;
          this.handleSubmit(submitEvent, isAction);
        } catch (e) {
          console.log(e);
        }
      } else {
        try {
          let submitEvent = {};
          submitEvent.EventId = this.selectedEvent.EventId;
          submitEvent.StallholderId = this.selectedStallHolder.StallholderId;
          submitEvent.ProductId = this.ManualProductObj.ProductId;

          let isAction = "Delete";
          this.handleSubmit(submitEvent, isAction);
        } catch (e) {
          console.log(e);
        }
      }
    },
    // IsCashOut
    handleCreateIsCashOut: function () {
      if (!this.IsCashOut) {
        try {
          let isAction = "Create";
          let submitEvent = {};
          const foundCashOutProduct = this.allProducts.find(
            (product) => product.IsCashOut && product.Deleted
          );
          if (foundCashOutProduct) {
            submitEvent = { ...foundCashOutProduct };
            isAction = "Edit";
          } else {
            submitEvent.IsCashOut = true;
            submitEvent.EventId = this.selectedEvent.EventId;
            submitEvent.StallholderId = this.selectedStallHolder.StallholderId;
            submitEvent.CategoryId = "TBC";
            submitEvent.ProductName = "Cashout";
            submitEvent.ShortName = "Cashout";
          }
          submitEvent.Deleted = false;

          this.handleSubmit(submitEvent, isAction);
        } catch (e) {
          console.log(e);
        }
      } else {
        try {
          // So this just updates the deleted flag????
          let submitEvent = {};
          submitEvent.EventId = this.selectedEvent.EventId;
          submitEvent.StallholderId = this.selectedStallHolder.StallholderId;
          submitEvent.ProductId = this.IsCashOutProductObj.ProductId;

          let isAction = "Delete";
          this.handleSubmit(submitEvent, isAction);
        } catch (e) {
          console.log(e);
        }
      }
    },
    handleSubmit: function (obj, action) {
      try {
        let event_item = [
          {
            Type: "product",
            Action: action,
            Properties: obj,
          },
        ];

        let submit = {
          event_items: event_item,
        };
        this.createCategories(submit)
          .then((response) => {
            console.log("response");
            console.log(response);

            iziToast.success({
              title: "Product",
              message: "Successfully " + action + " record!",
              position: "topRight",
            });

            this.$emit("refresh-data");
          })
          .catch((err) => {
            console.log("err");
            console.log(err);

            iziToast.warning({
              title: "Product",
              message: "Fail to inserted record!",
              position: "topRight",
            });
          });
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>
<style scoped>
h1 {
  color: #a09c94;
  font-family: sans-serif;
}
</style>
